<template>
  <div>
    <div
      :class="[
        'sidebar',
        {
          'close-sidebar': currentUrl.includes(urls.services),
          'lang-en': $i18n.locale === 'en',
        },
      ]"
      ref="sidebar"
    >
      <div class="yektanet-brand-container" style="font-weight: 700">
        <accounts-logo-icon />
        {{ `${$t("account_management")}` }}
      </div>
      <a
        v-for="item in items"
        :key="item.url"
        :href="item.url"
        :class="[
          'p-0 sidebar-item btn btn-link',
          {
            selected: currentUrl.includes(item.url),
          },
        ]"
      >
        <i
          :class="[
            'sidebar-item-icon font-5 position-relative mx-1',
            item.icon,
          ]"
          data-bs-toggle="tooltip"
          data-bs-placement="left"
          :title="item.title.desktop"
        >
          <span v-if="item.hasRedDot" class="red-dot"></span>
        </i>
        <span>{{ item.title.desktop }}</span>
      </a>
    </div>
    <div class="mobile-sidebar d-flex d-md-none flex-row-reverse">
      <a
        v-for="item in items.filter((e) => e.title.mobile)"
        :key="item.url"
        :href="item.url"
        :class="[
          'p-0 sidebar-item btn btn-link d-flex flex-column py-2 justify-content-between',
          {
            selected: currentUrl.includes(item.url),
          },
        ]"
        @click="_sidebar('close')"
      >
        <i
          :class="['sidebar-item-icon position-relative mb-2 mt-1', item.icon]"
        >
          <span v-if="item.hasRedDot" class="red-dot"></span>
        </i>
        <span>{{ item.title.mobile }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import AccountsLogoIcon from "../../img/accountsLogo.svg";
import { _sidebar } from "~/utils";

export default {
  components: {
    AccountsLogoIcon,
  },
  data: (vm) => {
    const {
      services,
      userProfile,
      applicationListView,
      phoneManagementView,
      accountEmail,
      accountChangePassword,
      accountSetPassword,
      socialaccountConnections,
    } = sData.urls;

    return {
      items: [
        {
          url: services,
          title: {
            mobile: vm.$t("khadamat"),
            desktop: vm.$t("khadamat"),
          },
          icon: "fas fa-th",
          hasRedDot: false,
          class: {
            mobile: "py-1",
            desktop: "",
          },
        },
        {
          url: userProfile,
          title: {
            mobile: "",
            desktop: vm.$t("user_info"),
          },
          icon: "fad fa-user-circle",
          hasRedDot: false,
          class: {
            mobile: "",
            desktop: "",
          },
        },
        {
          url: applicationListView,
          title: {
            mobile: vm.$t("services"),
            desktop: vm.$t("services"),
          },
          icon: "fa fa-tv-alt",
          hasRedDot: false,
          class: {
            mobile: "",
            desktop: "",
          },
        },
        {
          url: phoneManagementView,
          title: {
            mobile: vm.$t("mobile"),
            desktop: vm.$t("mobile_management"),
          },
          icon: "fas fa-phone",
          hasRedDot: !sData.isMobileVerified,
          class: {
            mobile: "",
            desktop: "",
          },
        },
        {
          url: accountEmail,
          title: {
            mobile: vm.$t("email"),
            desktop: vm.$t("email_management"),
          },
          icon: "fas fa-envelope-open",
          hasRedDot: !sData.isEmailVerified,
          class: {
            mobile: "",
            desktop: "",
          },
        },
        {
          ...(sData.currentUrl.includes(accountSetPassword)
            ? {
                url: accountSetPassword,
                title: {
                  mobile: "",
                  desktop: vm.$t("choose_password"),
                },
              }
            : {
                url: accountChangePassword,
                title: {
                  mobile: "",
                  desktop: vm.$t("change_password"),
                },
              }),
          icon: "fad fa-lock-alt",
          hasRedDot: false,
          class: {
            mobile: "",
            desktop: "",
          },
        },
        {
          url: socialaccountConnections,
          title: {
            mobile: "",
            desktop: vm.$t("social_accounts"),
          },
          icon: "fad fa-users",
          hasRedDot: false,
          class: {
            mobile: "",
            desktop: "",
          },
        },
      ],
      ...sData,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (window.localStorage.getItem("sidebar") === "open") {
        _sidebar("open");
      } else if (window.localStorage.getItem("sidebar") === "close") {
        _sidebar("close");
      }
      setTimeout(() => {
        this.$refs.sidebar.classList.add("transition");
        document
          .querySelector(".profile-content-container")
          .classList.add("transition");
        document.querySelector(".navbar").classList.add("transition");
        document.querySelector(".dim-layer").classList.add("transition");
      }, 0);

      window.matchMedia("(max-width: 767px)").addListener((mq) => {
        if (mq.matches) {
          _sidebar("close");
        }
      });

      document
        .querySelector(".dim-layer")
        .addEventListener("click", function () {
          _sidebar("toggle");
        });
    });
  },
};
</script>

<style lang="scss">
.sidebar {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 230px;
  overflow: hidden;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 2;

  &.lang-en {
    right: unset;
    left: 0;
    .sidebar-item {
      border-right: unset;
      border-left: 5px solid transparent;
      text-align: left;
    }
  }
  &.close-sidebar {
    width: 49px;

    .yektanet-brand-container svg {
      transform: scale(0.8) translateX(10px);
    }
  }

  &.close-sidebar.lang-en {
    .yektanet-brand-container svg {
      transform: scale(0.8);
    }
  }

  .sidebar-item {
    padding: 11px 5px;
    cursor: pointer;
    font-weight: 500;
    color: #757575;
    width: 230px;
    text-align: right;
    border: none;
    border-right: 5px solid transparent;
    border-radius: unset;
    text-decoration: none;

    &.selected {
      color: #444;
      background-color: #edf7ff;
      border-color: #2476ad;
    }

    &:hover {
      background-color: #edf7ff;
      border-color: #2476ad;
    }

    i {
      display: inline-block;
      width: 20px;
      text-align: center;
      vertical-align: middle;
    }

    .sidebar-item-icon {
      width: 40px;
      height: 50px;
      line-height: 50px;
    }
  }

  .yektanet-brand-container {
    height: 57px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 10px;
    overflow: hidden;

    svg {
      transition: all 0.15s;
    }
  }
}
.mobile-sidebar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 5;
  .red-dot {
    top: -3px;
    left: calc(50% + 8px);
  }
  .sidebar-item {
    flex-basis: 25%;
    color: #7a7a7a;
    fill: #7a7a7a;
    text-decoration: none;

    &.selected {
      color: rgb(36, 118, 173);
      fill: rgb(36, 118, 173);
    }
    span {
      padding: 0 5px;
    }
    i {
      font-size: 1.5rem;
    }
  }
}
.red-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: tomato;
  margin-right: 0.5rem;
  position: absolute;
  top: 12px;
  left: 5px;
}
.navbar.close-sidebar {
  right: 49px;
}
.navbar.lang-en.close-sidebar {
  left: 49px;
}
.profile-content-container.close-sidebar {
  margin-right: 49px;
}
.profile-content-container.lang-en.close-sidebar {
  margin-left: 49px;
}
.profile-content-container.close-sidebar .modal {
  width: calc(100% - 49px);
}
@media screen and (max-width: 767px) {
  .dim-layer.close-sidebar {
    display: none;
  }
  .sidebar.close-sidebar {
    width: 0;
  }
  .navbar.close-sidebar {
    right: 0;
  }
  .navbar.lang-en.close-sidebar {
    left: 0;
  }
  .profile-content-container.close-sidebar {
    left: 0;
    margin-right: 0;
  }
  .profile-content-container.lang-en.close-sidebar {
    right: 0;
    margin-left: 0;
  }
  .profile-content-container.close-sidebar .modal {
    width: 100%;
  }
}
</style>
